var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaceComposerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.261,
    height: 16.261,
    viewBox: "0 0 16.261 16.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "face-id-svgrepo-com",
    transform: "translate(-2.25 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2275",
    "data-name": "Path 2275",
    d: "M7.9,19.925c-4.036,0-4.9-.865-4.9-4.9",
    transform: "translate(0 -2.164)",
    fill: "none",
    stroke: "#a0a0a0",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2276",
    "data-name": "Path 2276",
    d: "M19.925,15.024c0,4.036-.865,4.9-4.9,4.9",
    transform: "translate(-2.164 -2.164)",
    fill: "none",
    stroke: "#a0a0a0",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2277",
    "data-name": "Path 2277",
    d: "M15.024,3c4.036,0,4.9.865,4.9,4.9",
    transform: "translate(-2.164)",
    fill: "none",
    stroke: "#a0a0a0",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2278",
    "data-name": "Path 2278",
    d: "M8,14a4.1,4.1,0,0,0,6.561,0",
    transform: "translate(-0.9 -1.98)",
    fill: "none",
    stroke: "#a0a0a0",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2279",
    "data-name": "Path 2279",
    d: "M9,10.009V10",
    transform: "translate(-1.08 -1.26)",
    fill: "none",
    stroke: "#a0a0a0",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    "data-name": "Path 2280",
    d: "M15,10.009V10",
    transform: "translate(-2.16 -1.26)",
    fill: "none",
    stroke: "#a0a0a0",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    d: "M3,7.9C3,3.865,3.865,3,7.9,3",
    fill: "none",
    stroke: "#a0a0a0",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceComposerIcon);
export default __webpack_public_path__ + "static/media/face-composer-icon.f2cbe8cacce503544b66f8c5ddb45000.svg";
export { ForwardRef as ReactComponent };